<template>
  <div>
    <b-card>
      <b-row class="px-1 align-items-center justify-content-between">
        <h5> اجتماعات الهيئة العامة </h5>

      </b-row>
      <hr />
      <!-- <b-row>
        <b-col cols="12" lg="6" xl="4" md="12">
          <search-input placeholder="البحث بحسب الأسم" v-model="nameFilter" />
        </b-col>
      </b-row> -->
      <data-table
        ep="v2/general-authority-meetings"
        id="projects"
        :fields="fields"
        striped
        ref="holdGeneralBodyMeetingsTable"
      >
        <template #cell(partner_entity)="{ value }" >
          <partner-entity-formatter :value="value" ></partner-entity-formatter>
        </template>

        <template #cell(_)="row">
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              variant="flat-info"
              @click="row.toggleDetails"
              title="عرض المزيد من المعلومات"
              size="sm"
              class="btn-icon rounded-circle"
              v-b-tooltip.hover.v-info.top
            >
              <feather-icon icon="InfoIcon" size="1.8x" color="#4fc98c" />
            </b-button>
          </div>
        </template>
        <template #row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col md="12" class="mb-2 d-flex">
                <strong> عدد أعضاء الهيئة العامة:</strong>
                <div class="text-info mx-1">{{ row.item.general_authority_members_count }}</div>
              </b-col>
              <b-col md="12" class="mb-2 d-flex">
                <strong> جدول الأعمال :</strong>
                <div class="text-info mx-1" v-html="row.item.business_schedule"></div>
              </b-col>
              <b-col md="12" class="mb-2 d-flex" v-if="row.item.does_meeting_include_nomination_of_board_members !== 0">
                <strong>  أسماء المرشحين  : </strong>
                <div class="text-info mx-1" v-html="row.item.directors_board_candidates_membership_names"></div>
              </b-col>
            </b-row>

            <b-button
              size="sm"
              variant="outline-secondary"
              @click="row.toggleDetails"
            >
              عرض اقل
            </b-button>
          </b-card>
        </template>
      </data-table>

      <hold-general-body-meeting
        :loading="loading"
        mainTitle="بيانات معاملة عقد اجتماع هيئة عامة"
        @confirm="onConfirmAddRequest"
        v-model="holdGeneralBodyMeeting"
        :intializeForm="form"
        ref="holdGeneralBodyMeeting"
      />
    </b-card>
  </div>
</template>

<script>
import dataTable from "@/components/data-table";
import {
  BButton,
  BRow,
  BCol,
  BCard,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormRadioGroup,
  BFormGroup,
  VBTooltip
} from "bootstrap-vue";
import FormModal from "@/components/FormModal.vue";
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash.debounce";
import SearchInput from "@/components/SearchInput.vue";
import Ripple from "vue-ripple-directive";

import HoldGeneralBodyMeeting from "@/modules/ngo/transactions/components/Add/HoldGeneralBodyMeeting.vue";
export default {
  components: {
    dataTable,
    BDropdown,
    BDropdownItem,
    VBTooltip ,
    BButton,
    BRow,
    BCol,
    BCard,
    BBadge,
    FormModal,
    SearchInput,
    BFormRadioGroup,
    BFormGroup,
    HoldGeneralBodyMeeting
  },
  methods: {
    ...mapActions("AdministrativeStatus/GeneralAuthorityMeeting", [
      "deleteHoldGeneralBodyMeeting",
    ]),
    ...mapActions("AdministrativeStatus/Transactions/Transactions", [
      "createTransactions",
    ]),
    onUpdateClicked(form) {
      var toUpdate = {
        id: form.id,
        full_name: form.full_name,
        id_number: form.id_number,
        phone_number: form.phone_number,
        gender: form.gender,
        dob: form.dob,
        active: form.active,
        can_vote: form.can_vote,
      };
      this.$refs.memberModal.init(toUpdate);
      this.formModal = true;
    },
    onAddClicked() {
      this.$refs.memberModal.init({
        active: true,
        can_vote: true,
      });
      this.formModal = true;
    },
    onDeleteClicked(form) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف عقد الاجتماع", {
          title: "تأكيد حذف عقد اجتماع",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteHoldGeneralBodyMeeting(form.id).then(() => {
              this.$refs.holdGeneralBodyMeetingsTable.refreshTable();
            });
        });
    },

    async onModalConfirmed(form) {
      if (form.id)
        await this.updateMember(form).then(() => {
          this.$refs.holdGeneralBodyMeetingsTable.refreshTable();
        });
      else
        await this.addMember(form).then(() => {
          this.$refs.holdGeneralBodyMeetingsTable.refreshTable();
        });

      this.formModal = false;
    },
    async onConfirmAddRequest(form){
      const keys = Object.keys(form);
      var req = new FormData();
      req.append("slug", "collaboration_two_local_partners");
      for (const index in keys) {
        const key = keys[index];
        if(`${key}` ==='file') {
          req.append(`data[${index}][field_name]`, `${key}`);
          req.append(`data[${index}][field_value]`, form.file);

        }

        else if (`${key}` === 'ngo_name'){

        }
        else{
          req.append(`data[${index}][field_name]`, `${key}`);
          req.append(`data[${index}][field_value]`, `${form[key]}`);

        }
      }
      this.createTransactions(req).then(() => {
        this.$refs.collaborationTable.refreshTable();
        this.collaborationModal = false
      })
      .catch((err) => {
        console.log(err)
      });

    },
  },
  data() {
    return {
      formModal: false,
      form : {} ,
      holdGeneralBodyMeeting : false ,
      nameFilter: "",

      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "meeting_location",
          label: "مكان عقد الاجتماع",
        },
        { key: "first_meeting_date", label: "موعد الإجتماع الأول" },
        {
          key: "second_meeting_date",
          label: "موعد الاجتماع الثاني",
        },
        {
          key: "general_authority_members_who_can_attend_count",
          label: "عدد أعضاء الهيئة العامة الذين يحق لهم الحضور",
        },

        { key: "_", label: " " },
      ],
    };
  },
  watch: {
    nameFilter: debounce(function (val) {
      this.$refs.holdGeneralBodyMeetingsTable.setQueryParams({ search: val });
      this.$refs.holdGeneralBodyMeetingsTable.refreshTable();
    }, 500),
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  computed: {
    ...mapGetters("AdministrativeStatus/GeneralAuthority", ["loading"]),
    ...mapGetters("AdministrativeStatus/Transactions/Transactions", ["loading"]),
  },
  created() {
   let userData = JSON.parse(localStorage.getItem("user"))
   this.form.ngo_name = userData.ngo.name_ar
   this.form.ngo_id = userData.ngo.id

  },
  mounted(){
    this.$refs.holdGeneralBodyMeeting.init(this.form);
  }
};
</script>
